var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderConfirmed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_9454)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_472_9454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_472_9454)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_472_9454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_472_9454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.246 10.7452L12.4369 16.5542L10.1272 14.2562C9.789 13.9179 9.22906 13.9179 8.89076 14.2562C8.55252 14.5945 8.55252 15.1544 8.89076 15.4927L11.8187 18.4089C11.9936 18.5838 12.2153 18.6655 12.4369 18.6655C12.6586 18.6655 12.8801 18.5838 13.0551 18.4089L19.4824 11.9816C19.8323 11.6434 19.8323 11.0951 19.4824 10.7451C19.1441 10.4069 18.5959 10.4069 18.2459 10.7451",
    fill: "#439798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.72 2.33482C7.29271 2.49811 2.18355 7.85227 2.3352 14.2796C2.4052 17.3941 3.69998 20.2986 5.95129 22.445C8.14425 24.5329 10.9788 25.6644 13.9884 25.6644H14.2799C17.3944 25.5944 20.299 24.2996 22.4453 22.0483C24.5916 19.797 25.7347 16.8342 25.6648 13.7197C25.5949 10.6052 24.3 7.70062 22.0487 5.55431C19.7857 3.408 16.8346 2.26487 13.7201 2.33482M21.1739 20.8352C19.3425 22.7482 16.8813 23.8447 14.2334 23.903C11.5738 23.973 9.07749 22.9932 7.15282 21.1734C5.2281 19.3538 4.14327 16.8808 4.08498 14.2329C3.95668 8.7621 8.29595 4.21283 13.7551 4.08454H14C16.5546 4.08454 18.9692 5.05272 20.8356 6.82574C22.7486 8.65716 23.8451 11.1184 23.9034 13.7663C23.9734 16.4026 23.0052 18.9222 21.1738 20.8352",
    fill: "#439798"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_9454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderConfirmed);
export default __webpack_public_path__ + "static/media/orderConfirmed.5c16e7870d34327baa4125c6617d33e4.svg";
export { ForwardRef as ReactComponent };